export const PASSWORD_REQUIREMENTS =
  "Password must be at least 8 characters long with 1 number, 1 special character, 1 capital and 1 lowercase letter";
export const PASSWORD_EXP = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*_-]).{8,}/;
